export default __webpack_public_path__ + "static/media/Dinner.f508fe23.svg";